<template>
  <div
    v-if="visibility"
    class="chart section section-border--top section-border--right section-border--bottom"
  >
    <div class="chart__top">
      <TitleBlock
        class="chart-title"
        :text="title"
        color="default"
        :tip-text="tipText"
        :chart="true"
      />
    </div>
    <highchart :options="chartOptions[type]" :modules="modulesToAdd" />
  </div>
</template>

<script>
export default {
  name: "Chart",
  components: {
    TitleBlock: () => import("../elements/TitleBlock"),
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "1",
    },
    chartData: {
      type: Object,
      default: () => {},
    },
    visibility: {
      type: Boolean,
      default: true,
    },
    tipText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      modulesToAdd: ["exporting", "export-data", "data"],

      chartOptions: [
        {
          chart: {
            zoomType: "xy",
          },
          credits: {
            enabled: false,
          },
          title: {
            text: "",
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          xAxis: [
            {
              categories: this.chartData.categories,
              crosshair: true,
            },
          ],
          yAxis: [
            {
              // Primary yAxis
              labels: {
                style: {
                  color: "black",
                },
              },
              title: {
                text: "Changes",
                style: {
                  color: "black",
                },
              },
            },
            {
              // Secondary yAxis
              title: {
                text: "Average",
                style: {
                  color: "black",
                },
              },
              labels: {
                style: {
                  color: "black",
                },
              },
              opposite: true,
            },
          ],
          tooltip: {
            shared: true,
          },
          legend: {
            reversed: true,
          },
          series: [
            {
              color: {
                linearGradient: [0, 0, 0, 400],
                stops: [
                  [0, "#d8281b"],
                  [0.5, "#b5170f"],
                  [1, "#890000"],
                ],
              },
              name: "No. of legislative changes",
              type: "column",
              yAxis: 1,
              data: this.chartData.legislativeChanges,
            },
            {
              color: "#7ca6c6",
              name: "6 month rolling average",
              type: "spline",
              dashStyle: "shortdot",
              data: this.chartData.averageChanges,
            },
          ],
        },
        {
          chart: {
            type: "bar",
          },
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          xAxis: {
            categories: this.chartData.categories,
          },
          yAxis: {
            min: 0,
            title: {
              text: "No. of legislative changes",
            },
          },
          legend: {
            reversed: true,
          },
          plotOptions: {
            series: {
              stacking: "normal",
            },
          },
          series: this.chartData.series,
        },
        {
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          yAxis: {
            title: {
              text: "Benchmarking Value",
            },
          },
          xAxis: [
            {
              categories: this.chartData.categories,
              crosshair: true,
            },
          ],
          legend: {
            reversed: true,
          },

          plotOptions: {
            series: {
              label: {
                connectorAllowed: false,
              },
            },
          },

          series: this.chartData.series,

          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  legend: {
                    layout: "horizontal",
                    align: "center",
                    verticalAlign: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          yAxis: {
            title: {
              text: "Benchmarking Value",
            },
          },
          xAxis: [
            {
              categories: this.chartData.categories,
              crosshair: true,
            },
          ],

          legend: {
            reversed: true,
          },

          plotOptions: {
            series: {
              label: {
                connectorAllowed: false,
              },
            },
          },

          series: this.chartData.series,

          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  legend: {
                    layout: "horizontal",
                    align: "center",
                    verticalAlign: "bottom",
                  },
                },
              },
            ],
          },
        },
        {
          chart: {
            type: "bar",
          },
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          xAxis: {
            categories: this.chartData.categories,
          },
          yAxis: {
            min: 0,
            title: {
              text: "No. of legislative changes",
            },
          },
          legend: {
            reversed: true,
          },
          plotOptions: {
            series: {
              stacking: "normal",
            },
          },
          series: this.chartData.series,
        },
        {
          chart: {
            type: "bar",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          title: {
            text: "",
          },
          xAxis: {
            categories: this.chartData.categories,
          },
          yAxis: {
            min: 0,
            title: {
              text: "No. of legislative changes",
            },
          },
          legend: {
            reversed: true,
          },
          plotOptions: {
            series: {
              stacking: "normal",
            },
          },
          series: this.chartData.series,
        },
        {
          chart: {
            type: "column",
          },
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          xAxis: {
            categories: this.chartData.categories,
          },
          yAxis: {
            min: 0,
            title: {
              text: "No. of monthly regulatory events",
            },
          },
          legend: {
            reversed: true,
          },

          tooltip: {
            formatter() {
              return (
                "<b>" +
                this.x +
                "</b><br/>" +
                this.series.name +
                ": " +
                this.y +
                "<br/>" +
                "Total: " +
                this.point.stackTotal
              );
            },
          },
          plotOptions: {
            series: {
              stacking: "normal",
            },
          },
          series: this.chartData.series,
        },
        {
          title: {
            text: "",
          },
          credits: {
            enabled: false,
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  "printChart",
                  "separator",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                  "separator",
                  "downloadCSV",
                  "downloadXLS",
                  // "viewData",
                  // "openInCloud"
                ],
              },
            },
          },
          yAxis: {
            title: {
              text: "Impact Index",
            },
          },
          xAxis: [
            {
              categories: this.chartData.categories,
              crosshair: true,
            },
          ],

          legend: {
            reversed: true,
          },

          plotOptions: {
            series: {
              label: {
                connectorAllowed: false,
              },
            },
          },

          series: this.chartData.series,

          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  legend: {
                    layout: "horizontal",
                    align: "center",
                    verticalAlign: "bottom",
                  },
                },
              },
            ],
          },
        },
      ],
    };
  },
  watch: {
    chartData: {
      handler(newOptions) {
        if (this.type === "0") {
          this.chartOptions[0].series = [
            {
              color: {
                linearGradient: [0, 0, 0, 400],
                stops: [
                  [0, "#d8281b"],
                  [0.5, "#b5170f"],
                  [1, "#890000"],
                ],
              },
              name: "No. of legislative changes",
              type: "column",
              yAxis: 1,
              data: newOptions.legislativeChanges,
            },
            {
              color: "#7ca6c6",
              name: "6 month rolling average",
              type: "spline",
              dashStyle: "shortdot",
              data: newOptions.averageChanges,
            },
          ];
          this.chartOptions[0].xAxis = [{ categories: newOptions.categories }];
        } else {
          this.chartOptions[this.type].series = newOptions.series;
          this.chartOptions[this.type].categories = newOptions.categories;
          this.chartOptions[this.type].xAxis.categories = newOptions.categories;
        }
      },
    },
    deep: true,
  },
  created() {
    this.chartOptions.title = this.title;

    this.chartOptions.colors = { colors: ["#ff0000", "#ffa500", "#008000"] };
  },
};
</script>

<style scoped lang="scss">
.chart {
  margin-bottom: 5rem;
  &__top {
    display: flex;
    justify-content: space-between;
  }
  &-title {
    margin-bottom: 3rem;
    // width: 75px;
  }

  ::v-deep svg {
    .highcharts-exporting-group {
      transform: translate(0, -10px);
    }
  }

  ::v-deep {
    .highcharts-menu {
      text-indent: 0;
    }
  }
}
</style>
